<script setup lang="ts">
    import type { LocaleCode } from '~/i18n/locales';
    import type { TeaserDetailsItem } from '~/types/academy/baseTraining';
    import { parseStoryblokDateUTC } from '~/utils/date';

    const props = defineProps<{
        item: TeaserDetailsItem;
    }>();

    // we currently need to resolve the BCP 47 locale tag manually due to a bug in the vue i18n module.
    const { i18nLocale } = useLanguage() as unknown as { i18nLocale: LocaleCode };

    const courseItem = computed(() => (props.item.type === 'course' ? props.item : null));

    const startsAtDate = computed(() => {
        if (props.item.type !== 'event' || !props.item.startsAt) return null;
        return parseStoryblokDateUTC(props.item.startsAt);
    });
</script>

<template>
    <div class="teaser-card-details">
        <div
            v-if="courseItem?.durationMinutes"
            class="details-icon"
        >
            <TeaserIcon :icon="'hfp:clock'" />
            <span class="details-text">{{ courseItem.durationMinutes }} {{ $t('academy.duration.minutes') }}</span>
        </div>
        <div
            v-if="startsAtDate"
            class="details-icon"
        >
            <TeaserIcon :icon="'hfp:calendar'" />
            <span class="details-text">{{ $d(startsAtDate, 'short', i18nLocale) }}</span>
        </div>
        <div
            v-if="item.type === 'event' && item.location"
            class="details-icon"
        >
            <TeaserIcon :icon="'hfp:map-pin'" />
            <span class="details-text">{{ item.location }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .teaser-card-details {
        display: flex;
        flex-direction: column;
        gap: var(--spacing--05);
    }

    .details-icon {
        display: flex;
        align-items: center;
        gap: var(--spacing--05);
    }

    .details-text {
        font-size: var(--font-s);
        line-height: 1.2;
    }
</style>
